import { type CompareV2SettingsActionsType, COMPARE_V2_SETTINGS_INIT } from "../actions/CompareV2SettingsActions";
import { type CompareV2LabelType, compareV2Labels } from "../../utils/labels";
import type { NcPageUrlsType } from "../../../../common-deprecated/utils/aemPageUrlTypes";

export type CompareV2SettingsType = {
    initialized: boolean;
    compareV2Standalone: boolean;
    loadEtaValuesInCompare: boolean;
    hideReviewScoresInCompare: boolean;
    cardbImageHost: string;
    labels: Record<CompareV2LabelType, string>;
    pageUrls: NcPageUrlsType;
    financeGateway: string;
    offerFiltersFinanceApi: string;
    feefoReviewsMerchantId: string; // will use feefo instead of bazaarvoice when filled in
};

export const compareV2SettingsInitialState: CompareV2SettingsType = {
    initialized: false,
    compareV2Standalone: false,
    loadEtaValuesInCompare: false,
    hideReviewScoresInCompare: false,
    cardbImageHost: "//t1-carassets.toyota-europe.com/",
    financeGateway: "",
    offerFiltersFinanceApi: "",
    pageUrls: {},
    labels: { ...compareV2Labels },
    feefoReviewsMerchantId: "",
};

const CompareV2SettingsReducer = (
    state: CompareV2SettingsType = compareV2SettingsInitialState,
    action: CompareV2SettingsActionsType,
): CompareV2SettingsType => {
    switch (action.type) {
        case COMPARE_V2_SETTINGS_INIT: {
            return { ...state, ...action.initState, initialized: true };
        }

        default:
            return state;
    }
};

export default CompareV2SettingsReducer;
